module.exports = __webpack_public_path__ + "static/img/taide-art-black.fe7f957.svg";